module.exports = __webpack_public_path__ + "img/header.05c96966.jpg";